import {fetchAuthSession} from 'aws-amplify/auth';

// Backend API base URL with any trailing slash removed.
export const getApiBaseUrl = (): string | undefined =>
  (import.meta.env.VITE_API as string | undefined)?.replace(/\/$/, '');

export const getAccessToken = async (): Promise<string | undefined> => {
  const {accessToken} = (await fetchAuthSession()).tokens ?? {};
  return accessToken?.toString();
};
